import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Polyfills that are currently not configured via babel
import 'whatwg-fetch'
import 'document-register-element/build/document-register-element'
import 'intl'

import 'mutationobserver-shim'
import Vue from 'vue'
import '@/plugins/bootstrap-vue'
import '@/mixins/import'
import { register as registerCustomElements } from '@/helper/customElementsHelper'
import * as Store from '@/store'
import vueCustomElement from 'vue-custom-element'
import { createProvider } from '@/apollo'

import DynSlot from '@/components/generic/DynSlot'
import Tooltip from '@/components/generic/Tooltip'

import Config from '../config/otelo'
import { globalStoreConfig } from '@/store/config'
import { storeConfig } from '@/store/config/otelo'

import ShopWrapper from './components/process/generic/Checkout/otelo/ShopWrapper'
import OrderWrapper from '@/components/process/generic/Order/otelo/OrderWrapper'
import OppwaCC from '@/components/generic/OppwaCC'
import ErrorView from './components/generic/MessageView/ErrorList'

const API_BASE_URL = process.env.VUE_APP_OTELO_API_BASE_URL || process.env.VUE_APP_API_BASE_URL
const GRAPHQL_HTTP = process.env.VUE_APP_OTELO_GRAPHQL_HTTP || process.env.VUE_APP_GRAPHQL_HTTP

const TRIGGER_SESSION_TRANSFER = 'getSessionStorage'
const TRANSFER_KEY = 'sessionStorage'

Vue.use(Config, {
  apiUrl: API_BASE_URL
})

let store

// transfers sessionStorage from one tab to another

function sessionStorageTransfer (event) {
  if (!event) { event = window.event } // ie suq
  if (!event.newValue) return
  // do nothing if no value to work with
  if (event.key === TRIGGER_SESSION_TRANSFER) {
    // another tab asked for the sessionStorage -> send it
    localStorage.setItem(TRANSFER_KEY, JSON.stringify(sessionStorage.getItem('portal-session')))
    // the other tab should now have it, so we're done with it.
    localStorage.removeItem(TRANSFER_KEY) // <- could do short timeout as well.
  } else if (event.key === TRANSFER_KEY) {
    // another tab sent data <- get it
    if (sessionStorage.getItem('portal-session') != null) {
      // other tab was quicker. ignore this one
      return
    }
    const data = JSON.parse(event.newValue)
    sessionStorage.setItem('portal-session', data)
    store = Store.createStore({
      ...globalStoreConfig,
      ...storeConfig
    })
    initializeApplication()
  }
}

// listen for changes to localStorage
if (window.addEventListener) {
  window.addEventListener('storage', sessionStorageTransfer, false)
} else {
  window.attachEvent('onstorage', sessionStorageTransfer)
}
// The opened tab requests the session storage content
// this is performed async
// wann wollen wir abrufen?
//   neuer Tab!
//   1. aktuell keine portal-session
//   2. (window.history = 1)
if (sessionStorage.getItem('portal-session') == null) {
  localStorage.setItem(TRIGGER_SESSION_TRANSFER, 'foobar')
  localStorage.removeItem(TRIGGER_SESSION_TRANSFER, 'foobar')
  // if there is no other tab open, nobody will answer :(
  // so we have to set a timeout to do the stuff ourself :)
  setTimeout(function () {
    if (sessionStorage.getItem('portal-session') == null) {
      initializeStore()
      initializeApplication()
    }
  }, 100)
} else {
  initializeStore()
  initializeApplication()
}
// End transfers sessionStorage from one tab to another
function initializeStore () {
  store = Store.createStore({
    ...globalStoreConfig,
    ...storeConfig
  })
  store.commit('selectBrand', 'otelo')
  store.commit('selectRetailerId', null)
  store.commit('selectType', 'DELIVERY')
  // ggf. hier auf ENVs gehen, wenn nötig -> process.env.OTELO_CLIENT_ID + OTELO_CLIENT_SECRET
  store.commit('selectClient', { id: 'otelo', secret: 'otelo' })
  store.commit('selectBaseUrl', API_BASE_URL)
}

function initializeApplication () {
  const apolloProvider = createProvider(store, {
    autoLogoutMessage: 'Es ist ein technischer Fehler aufgetreten. Sie wurden zur Sicherheit abgemeldet. Bitte melden Sie sich erneut an. Sollten die Probleme bestehen bleiben, so wenden Sie sich an die Hotline.',
    httpEndpoint: GRAPHQL_HTTP,
    restEndpoint: API_BASE_URL
  })

  Vue.component('dyn-slot', DynSlot)

  Vue.config.productionTip = false

  Vue.config.ignoredElements = [
    // Use a `RegExp` to ignore all elements that start with "ion-"
    // 2.5+ only
    // /^ion-/
  ]

  Vue.use(vueCustomElement)
  Vue.component('dyn-slot', DynSlot)

  registerCustomElements({
    // generics
    'app-tooltip': Tooltip,
    'app-shop-wrapper': ShopWrapper,
    'app-order-wrapper': OrderWrapper,
    'app-oppwa': OppwaCC,
    'app-error-view': ErrorView
  }, store, apolloProvider)
}
